export const headerLinks = [
    { name: "Inicio", href: "/", },
    {name:"Nuestros Productos", href: "/nuestros-productos"},
    { name: "Nosotros", href: "/nosotros" },
    { name: "Preguntas Frecuentes" , href :"/preguntas-frecuentes"},
    { name: "Contacto" , href :"#footer-quality-seal"},
];